import React from 'react';

export default function EmptyState({ icon, title, description, action }) {
  return (
    <div className="flex min-h-[220px] flex-col items-center justify-center rounded-xl border border-dashed border-slate-700 bg-slate-800/40 px-6 py-10 text-center">
      <div className="mb-4 rounded-full bg-slate-900/80 p-4 text-slate-500">{icon}</div>
      <h3 className="text-lg font-semibold text-slate-300">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-slate-500">{description}</p>
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
